import React, { useState } from 'react'
import { AiFillLike } from 'react-icons/ai'
import { BsCheck2 } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import Button from '../../Components/Button'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/DesignStyle.module.css"
import Switch from "react-switch";
import like from "../../Assets/like.svg"
import dislike from "../../Assets/dislike.svg"

export default function DesignStyle() {

  const [designStyles, setDesignStyles] = useState(['https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?cs=srgb&dl=pexels-vecislavas-popa-1571460.jpg&fm=jpg','https://www.decorilla.com/online-decorating/wp-content/uploads/2018/10/modern-interior-design-grey-living-room2.png','https://cdn.pixabay.com/photo/2016/11/18/17/20/living-room-1835923__480.jpg','https://cdn.pixabay.com/photo/2014/08/11/21/39/wall-416060__340.jpg','https://img.freepik.com/premium-photo/tropical-interior-design-living-room_269031-60.jpg?w=2000','https://www.decorpot.com/images/breadcumb/Living-room-Mob.jpg','https://media.designcafe.com/wp-content/uploads/2020/03/21013530/interior-design-trends-hyderabad-2020.jpg','https://www.beautifulhomes.com/content/dam/asianpaintsbeautifulhomes/magazine/how-it-works/pc/SuitedForAllBudgets_AP_Nilaya_2_1862.png','https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlGlitLuMVOoUG6nBZdZuXmtxjrtLOlywlLg&usqp=CAU'])
  const [selectedStyles, setSelectedStyles] = useState([])
  const navigate = useNavigate()

  const [completed, setCompleted] = useState(false)
  const [quizOutput, setQuizOutput] = useState(['Modern & Elegant','Embracing Rawness','The Outside In'])

  const [view, setView] = useState('Grid')
  const [currentIndex, setCurrentIndex] = useState(0)

  return (
    <React.Fragment>
      <QuizHeader step3 />
      {!completed ? <div className={styles.container}>
        <header>
          <div></div>

          <div style={{marginLeft:180}}>
          <h2>Office Style</h2>
          <h3>Help us with your preferred office style.</h3>
          </div>

          <div style={{display:'flex',alignItems:'center',gap:10}}>
            <p className={view == 'Grid' && styles.activeSwitch}>Grid View</p>
              <div onClick={()=>{
                if(view == 'Grid') {
                  setView('Full')
                } else {
                  setView('Grid')
                }
              }} className={styles.switch}>
                <div style={{left: view == 'Grid' && 4 ,right:view == 'Full' && 4}} className={styles.switchInner}></div>
              </div>
            <p className={view == 'Full' && styles.activeSwitch}>Full View</p>
          </div>
        </header>

        {view == 'Grid' && <div>
        <div className={styles.gridViewContainer}>
          {designStyles.map(s => {
            return <div className={styles.gridView} onClick={()=>{
              if(!selectedStyles.includes(s)) {
                setSelectedStyles([...selectedStyles, s])
              } else {
                setSelectedStyles(selectedStyles.filter(j => j !== s))
              }
            }}>
              <img src={s} />
              <span className={styles.selection}>
                {selectedStyles.includes(s) ? <div>
                  <BsCheck2 size={14} />
                </div> : null}
              </span>
              <div className={styles.gridOverlay}></div>
            </div>
          })}
        </div>
        <div style={{display:'flex',justifyContent:'center'}}>
        <Button height={56} width={320} onClickHandler={()=>setCompleted(true)} radius={10} mt={32} title="Continue" />
        </div>
        </div>}

        {view == 'Full' && <div>
          <div className={styles.fullImage}>
            <img src={designStyles[currentIndex]} />
            <div className={styles.fullOverlay}></div>
            <div className={styles.imageBtns}>
            <button onClick={()=>{
              if(currentIndex == designStyles.length - 1){
                setCompleted(true)
              } else {
                setCurrentIndex(currentIndex + 1)
              }
              }}><img src={like} /></button>
            <button onClick={()=>{
              if(currentIndex == designStyles.length - 1){
                setCompleted(true)
              } else {
                setCurrentIndex(currentIndex + 1)
              }
              }}><img src={dislike} /></button>
            </div>
          </div>
          </div>}

      </div> : <div className={styles.container}>
      <header>
          <h2>Congratulations!</h2>
          <h3>Here are your Design Style results.</h3>
        </header>
                        <div className={styles.quizContainer}>
                            {quizOutput.map((item,index) => {
                                return <div className={styles.quiz}>
                                <div className={styles.quizImage}>
                                    <img src="http://cdn.home-designing.com/wp-content/uploads/2022/02/modern-wooden-dining-chairs-with-arms-barrel-backrest-design-tapered-legs-mid-century-modern-danish-furniture-for-dining-room-seating-for-sale-online-light-oak-finish.jpg" />
                                    <div className={index == 0 ? styles.greenQuizLikeBtn : index == 1 ? styles.orangeQuizLikeBtn : styles.greyQuizLikeBtn}>
                                        <div>
                                            <AiFillLike color={index == 0 ? '#0AD071' : index == 1 ? "#DF8823" : '#757575'} size={20} />
                                        </div>
                                        <p>32<span>%</span></p>
                                    </div>
                                </div>
                                <div className={styles.quizContent}>
                                    <h2>{item}</h2>
                                    <ul>
                                        <li><span>Overall look & feel:</span> Clean and uncomplicated spaces</li>
                                        <li><span>Color palette:</span> Whites, Grays and Earthy tones</li>
                                        <li><span>Materials:</span> Wood and Concrete</li>
                                    </ul>
                                </div>
                            </div>
                            })}
                        </div>
                        <div style={{display:'flex',justifyContent:'center'}}>
                      <Button height={56} width={320} onClickHandler={()=>navigate('/quiz/spaceconfig')} radius={10} mt={32} title="Continue" />
                    </div>
            </div>}
    </React.Fragment>
  )
}
